export default __webpack_public_path__ + "static/GA-vert-3bbb5ac030510d4192057b453c9d34bc.svg";